import React, { ReactNode } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { IconButton } from "@fluentui/react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/hooks";
import { navigateBack } from "../../redux/feature/general/navigation-slice";
import { DOCUMENTS_LISTS } from "../../utils/constants/navigation";
import { tenantConfigurationState } from "../../redux/feature/settings/configurations-slice";

export interface HeaderPanelProps {
  children: ReactNode;
  borderColor?: string;
  enableBackArrow?: boolean;
  onBackArrowClick?: () => void;
  applyPadding?: boolean;
  headerRowJustifyContent?: string;
}

const classNames = mergeStyleSets({
  tenantHeader: {
    width: "100%",
    backgroundColor: "var(--color-lightblue)",
    paddingLeft: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "var(--color-blue)",
  },
  headerPanelRow: {
    padding: "0.5rem 0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  backButton: {
    cursor: "pointer",
    margin: 0,
    padding: 0,
    height: "16px",
    selectors: {
      ":hover": {
        background: "none",
        color: "var(--color-black)",
      },
    },
  },
});

function HeaderPanel({
  children,
  borderColor,
  enableBackArrow,
  onBackArrowClick,
  applyPadding,
  headerRowJustifyContent,
}: HeaderPanelProps) {
  const dispatch = useAppDispatch();
  const configurationState = useAppSelector(tenantConfigurationState);

  function back() {
    dispatch(navigateBack(DOCUMENTS_LISTS));
  }

  let headerPanelRowStyle = {};
  if (headerRowJustifyContent) {
    headerPanelRowStyle = { justifyContent: headerRowJustifyContent };
  }

  return (
    <div>
      <div className={classNames.tenantHeader}>{configurationState.selected}</div>
      <div className="headerTitle" style={{ padding: applyPadding ? "0 0.5rem 0 0.5rem" : "" }}>
        <div className={classNames.headerPanelRow} style={headerPanelRowStyle}>
          {enableBackArrow && (
            <IconButton
              iconProps={{ iconName: "ChevronLeft" }}
              ariaLabel="Go Back"
              className={classNames.backButton}
              onClick={() => {
                if (onBackArrowClick) onBackArrowClick();
                else back();
              }}
            />
          )}
          {children}
        </div>
        <div
          style={{
            borderBottom: `0.15rem solid ${borderColor ?? "var(--color-green)"}`,
            width: "100%",
            height: "3px",
            borderRadius: "25px",
          }}
        />
      </div>
    </div>
  );
}

export default HeaderPanel;
